import Dfp from 'react-simple-dfp'

import { CenteringDiv, FlexRowDiv, H1 } from 'components/generic/HomePageComponents'
import { AdContainerDiv, DarkButton } from './Styled'
import HowItWorksCard from './HowItWorksCard'

const HowItWorksCardsContainer = ({ hiwStep1, hiwStep2, hiwStep3, hiwStepCtaLink }) => (
  <FlexRowDiv p='0px 0px 48px 0px'>
    <AdContainerDiv display={['none', 'none', 'flex', 'flex']}>
      <Dfp
        display='flex'
        id='div-gpt-ad-1587405371277-0'
        adUnitPath='/23314643/home-leaderboard'
        adSize={[728, 90]}
        adCollapse={true}
      />
    </AdContainerDiv>
    <AdContainerDiv display={['flex', 'flex', 'none', 'none']}>
      <Dfp
        id='div-gpt-ad-1587405371277-1'
        adUnitPath='/23314643/home-leaderboard'
        adSize={[320, 50]}
        adCollapse={true}
      />
    </AdContainerDiv>
    <CenteringDiv maxWidth='1259px' mb='50px' width='100%' mt='90px'>
      <H1 fontSize={['30px', '40px', '50px']} lineHeight='50px' textAlign='center' mt='0px'>
        Here&apos;s How It Works
      </H1>
      <FlexRowDiv
        flexDirection={['column', 'column', 'column', 'row']}
        justifyContent='space-around'
        alignItems={['center', 'center', 'center', 'center', 'flex-start']}
        marginLeft={['0px', '0px', '0px', '40px']}
      >
        <HowItWorksCard step='STEP 1' content={hiwStep1} />
        <HowItWorksCard step='STEP 2' content={hiwStep2} />
        <HowItWorksCard step='STEP 3' content={hiwStep3} />
      </FlexRowDiv>
      <DarkButton
        fontSize={['18px', '18px', '18px', '25px']}
        fontWeight='700'
        mt='40px'
        padding='10px 60px'
        border='5px mainColor solid'
        href={hiwStepCtaLink}
      >
        Begin Your Search
      </DarkButton>
    </CenteringDiv>
  </FlexRowDiv>
)

export default HowItWorksCardsContainer
